import React from 'react';
import moment from 'moment';
import { Form } from 'components';
import TEXT_CAPTIONS from './constants';
import StaffPresentSelect from './StaffPresentSelect';
import useLaunchDarkly from 'hooks/useLaunchDarkly';

const BottleActivityForm = ({ activity, useDate = true, forceStaff }) => {
  const flags = useLaunchDarkly();
  const enableBottleType = flags['online-ent-bottlefeedingreport'];
  return (
    <div className="form__body">
      {useDate && (
        <div className="form__row form__row--datetime">
          <Form.DatePicker label="Date" name="date" defaultValue={moment(activity.activity_time).toDate()} required />

          <Form.TimeInput label="Time" name="time" defaultValue={Helpers.formatTime(activity.activity_time)} required />
        </div>
      )}

      <div className="form__row form__row--formula">
        {enableBottleType && (
          <Form.Select
            name="bottle_type"
            title="Select Milk or Formula Type"
            label="Milk/Formula Type"
            data-testid="bottle_type_select"
          >
            <Form.Select.Item label="Formula" value="Formula" dataTestId="bottle_type_formula" />
            <Form.Select.Item label="Breast Milk" value="Breast Milk" dataTestId="bottle_type_brest" />
            <Form.Select.Item label="Cow's Milk" value="Cow's Milk" dataTestId="bottle_type_cow" />
            <Form.Select.Item label="Other" value="Other" dataTestId="bottle_type_other" />
          </Form.Select>
        )}

        <Form.Input
          name="amount"
          defaultValue={activity.data.amount}
          placeholder="Amount"
          label="Amount Served (OZ)"
          data-testid="amount_served"
          required
        />
      </div>

      {enableBottleType ? (
        <div className="form__row form__row--consumed">
          <Form.Input
            name="bottle_consumed"
            defaultValue={activity.data.bottle_consumed}
            placeholder="Amount"
            label="Amount Consumed (OZ)"
            data-testid="bottle_consumed"
            isLessThanOrEqual
            equalToAmount="amount"
          />
          <StaffPresentSelect activity={activity} />
        </div>
      ) :
        <StaffPresentSelect activity={activity} />}

      <div className="form__row">
        <Form.Textarea
          name="description"
          defaultValue={activity.data.desc}
          placeholder="Description"
          label="Description"
        />
      </div>

      <div className="form__row">
        {forceStaff ? (
          TEXT_CAPTIONS.staffOnlyForce
        ) : (
          <Form.Checkbox
            type="circle"
            name="staffOnly"
            label={TEXT_CAPTIONS.staffOnly}
            defaultValue={flags['activities-feed'] ? activity.approval_status === 'pending' : activity.is_staff_only}
          />
        )}
      </div>
    </div>
  );
};

export default BottleActivityForm;
